import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Spinner } from "asocomponents"
import CartasSiniestrosServices from '../../../../modules/CartasSiniestros/application/CartasSiniestrosServices'

export default function VisorCartaSiniestro() {

  const { idCarta: idCartaEnviada } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [urlPdf, setUrlPdf] = useState("")
  //#endregion

  //#region funciones
  const cargarCartaEnviadaPdf = async (idCartaEnviada) => {
    const cartasSiniestrosService = new CartasSiniestrosServices()
    const blob = await cartasSiniestrosService.obtenerCartaEnviadaPdf(idCartaEnviada)

    if (blob) {
      const urlObjeto = URL.createObjectURL(blob)
      setUrlPdf(`${urlObjeto}#toolbar=0&navpanes=0&scrollbar=0`)
      return urlObjeto
    }

    return null
  }
  //#endregion

  //#region useEffect
  useEffect(() => {
    let urlObjeto

    const cargarDatos = async () => {
      setIsLoading(true)
      urlObjeto = await cargarCartaEnviadaPdf(idCartaEnviada)
      setIsLoading(false)
    };

    cargarDatos()

    return () => {
      if (urlObjeto)
        URL.revokeObjectURL(urlObjeto)
    }
  }, [idCartaEnviada])
  //#endregion

  if (isLoading) {
    return <Spinner color="red" size="50" />
  }

  return (
    <div
      id="root"
      style={{
        width: "100%",
        overflowX: "hidden"
      }}
    >
      {urlPdf && (
        <iframe
          src={urlPdf}
          title={`Carta ${idCartaEnviada}`}
          style={{
            width: "100%",
            height: "85vh",
            border: "none",
            display: "block"
          }}
        />
      )}
    </div>
  )
}
